import { createContext, useContext } from 'react';
import { noop } from 'es-toolkit';
import type { Column } from '../../types';

interface FormPopupContextType {
  openPopup: (columnId: string) => void;
  closePopup: () => void;
  isPopupOpen: boolean;
  currentColumn?: Column;
}

export const FormPopupContext = createContext<FormPopupContextType>({
  isPopupOpen: false,
  openPopup: noop,
  closePopup: noop
});

export const useFormPopup = () => {
  return useContext(FormPopupContext);
};
